module.exports = "./img/b930f5f93634872adf0e29b92d257c77.jpg";